import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class ChatService {
    getAuthToken() {
        const token = localStorage.getItem('adminToken');
        return token ? `Bearer ${token}` : '';
    }

    /**
     * Get all chat rooms
     */
    async getAllRooms(params = {}) {
        try {
            const response = await axios.get(`${API_URL}/chat/rooms`, {
                headers: { Authorization: this.getAuthToken() },
                params
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get messages in a room
     */
    async getRoomMessages(roomId, page = 1, limit = 50) {
        try {
            const response = await axios.get(`${API_URL}/chat/rooms/${roomId}/messages`, {
                headers: { Authorization: this.getAuthToken() },
                params: { page, limit }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Update room status
     */
    async updateRoomStatus(roomId, status) {
        try {
            const response = await axios.put(
                `${API_URL}/chat/rooms/${roomId}/status`,
                { status },
                { headers: { Authorization: this.getAuthToken() } }
            );
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Update room tags
     */
    async updateRoomTags(roomId, tags) {
        try {
            const response = await axios.put(
                `${API_URL}/chat/rooms/${roomId}/tags`,
                { tags },
                { headers: { Authorization: this.getAuthToken() } }
            );
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Update internal notes
     */
    async updateInternalNotes(roomId, notes) {
        try {
            const response = await axios.put(
                `${API_URL}/chat/rooms/${roomId}/notes`,
                { notes },
                { headers: { Authorization: this.getAuthToken() } }
            );
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get buyer info
     */
    async getBuyerInfo(buyerId) {
        try {
            const response = await axios.get(`${API_URL}/chat/buyer/${buyerId}/info`, {
                headers: { Authorization: this.getAuthToken() }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get chat analytics
     */
    async getChatAnalytics() {
        try {
            const response = await axios.get(`${API_URL}/chat/analytics`, {
                headers: { Authorization: this.getAuthToken() }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Upload file
     */
    async uploadFile(file) {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(`${API_URL}/chat/upload`, formData, {
                headers: {
                    Authorization: this.getAuthToken(),
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Create or get existing room for a buyer (Admin initiates chat)
     */
    async createOrGetRoom(buyerId) {
        try {
            const response = await axios.post(
                `${API_URL}/chat/rooms/create`,
                { buyerId },
                { headers: { Authorization: this.getAuthToken() } }
            );
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    handleError(error) {
        if (error.response) {
            throw new Error(error.response.data.message || 'An error occurred');
        }
        throw new Error('Network error. Please check your connection.');
    }
}

export default new ChatService();
